module.exports = __webpack_public_path__ + "img/9788961706186.dccd9094.jpg";